import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { AdminModal } from '../../../components/admin/admin-modal';
import AdminTextInput from '../../../components/admin/admin-text-input';

export function AddManufacturerModal({ show, onClose, handleAddManufacturer }) {
	const [manufacturerName, setManufacturerName] = useState('');
	const [fullName, setFullName] = useState('');
	const [email, setEmail] = useState('');
	const [companyName, setCompanyName] = useState('');
	const [password, setPassword] = useState('');
	const [validation, setValidation] = useState({});

	const [errors, setErrors] = useState('');
	const [displayError, setDisplayError] = useState('');
	const inputRef = useRef(null);
	const handleSave = () => {
		const isEmpty = (value) => !value || value.trim() === '';

		const validate = {
			fullName: !isEmpty(fullName),
			email: !isEmpty(email),	
			companyName: !isEmpty(companyName),
			manufacturerName: !isEmpty(manufacturerName)
		};

		const isValid = Object.values(validate).every(Boolean);

		setValidation(prev => ({ ...prev, ...validate }));

		if (!manufacturerName) {
			setErrors('Manufacturer Name must be valid.');		
		}

		if (!isValid) return;

		setErrors('');

		const data = {
			name: manufacturerName,
			siteUser: {
				UserName: email,
				Email: email,
				FullName: fullName,
				Organization: companyName,
				password: password
			}
		}

		handleAddManufacturer(data,() => {
				setManufacturerName('');
				onClose();
			},
			(err) => {
				setDisplayError(err);
			}
		);

	};

	const onCancel = () => {
		setManufacturerName('');
		setFullName('');
		setEmail('');
		setCompanyName('');
		setPassword('');
		setDisplayError('');
		setErrors('');
		setValidation({});
		onClose();
	}
	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, [show]);

	if (!show) {
		return null; // Don't render the modal if it's not being shown
	}

	return (
		<AdminModal
			show={true}
			onClose={onCancel}
			onSave={handleSave}
			modalTitle="Add Manufacturer"
			displayError={displayError}
			onHideError={() => { setDisplayError(''); }}
			label="Manufacturer Name"
		>
			<div className="admin-modal-row full">
				<div className="admin-modal-cell">
					<div
						className={
							'admin-default-input-text-wrap' +
							(errors ? ' input-validation-error' : '')
						}
					>
						<label className="admin-default-label">Manufacturer</label>
						<input
							className="admin-default-input-text"
							type="text"
							id="manufacturer-name"
							value={manufacturerName}
							onChange={(e) => {
								if (e.target.value == '') {
									setErrors('Manufacturer Name must be valid.');
								} else {
									setErrors('');
								}
								setManufacturerName(e.target.value);
							}}
							ref={inputRef}
						/>
						{errors && <p className="validation-error-message">{errors}</p>}
					</div>
				</div>
			</div>

			<div className="admin-modal-row">
				<div className="admin-modal-cell">
					<AdminTextInput
						id="full-name"
						label="First & Last Name"
						placeholder=""
						isRequired={true}
						value={fullName}
						validated={validation.fullName}
						onChange={(value) => {
							setValidation({ ...validation, fullName: value != '' });
							setFullName(value);
						}}
						requiredText="First & Last Name is required"
					/>
				</div>
				<div className="admin-modal-cell">
					<AdminTextInput
						id="email-address"
						label="Email Address"
						placeholder=""
						isRequired={true}
						value={email}
						validated={validation.email}
						onChange={(value) => {
							setValidation({ ...validation, email: value != '' });
							setEmail(value);
						}}
						requiredText="Email Address is required"
					/>
				</div>
			</div>			

			<div className="admin-modal-row">
				<div className="admin-modal-cell">
					<AdminTextInput
						id="company-name"
						label="Organization"
						placeholder=""
						isRequired={true}
						value={companyName}
						validated={validation.companyName}
						onChange={(value) => {
							setValidation({ ...validation, companyName: value != '' });
							setCompanyName(value);
						}}
						requiredText="Organization is required"
					/>
				</div>				
			</div>

			<div className="admin-modal-row">
				<div className="admin-modal-cell">
					<AdminTextInput
						id="password"
						label="Password"
						inputType="password"
						placeholder="Leave blank to let user create their own password"
						isRequired={false}
						value={password}
						onChange={(value) => {
							setPassword(value);
						}}
					/>
				</div>
			</div>

		</AdminModal>
	);
}

AddManufacturerModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	handleAddManufacturer: PropTypes.func.isRequired,
};
